import { ServiceLanguage, Tenant } from "albertine-shared-web";
import { z } from "zod";

const proposalSearchBaseSchema = z.object({
    tenant: Tenant,
    locale: ServiceLanguage,
    parentOrigin: z.url().optional(),
    mode: z.literal("agent-preview").optional(),
});

export const proposalSearchSchema = z.union([
    proposalSearchBaseSchema.extend({ id: z.string().min(1) }),
    proposalSearchBaseSchema.extend({ shareId: z.string().min(1) }),
]);

export type ProposalSearch = z.infer<typeof proposalSearchSchema>;

export function isPublicShareSearch(
    search: ProposalSearch,
): search is Extract<ProposalSearch, { shareId: string }> {
    return "shareId" in search;
}

export function isAgentPreviewSearch(
    search: ProposalSearch,
): search is Extract<ProposalSearch, { id: string }> {
    return "id" in search && search.mode === "agent-preview";
}
